import { SanityService } from "@modules/common/cms/sanityService"
import { HomeContentDto, homeContentDtoSchema } from "@modules/home/gateway/homeApiDto"
import { HomeApiGateway } from "@modules/home/gateway/homeApiGateway"
import { Language } from "@modules/language/utils/languageUtils"

export class HomeApi implements HomeApiGateway {
  async getHomeContent(language: Language) {
    const homeLanguage = language === "fr" ? "fr" : "en"

    const result = await SanityService.client.fetch<HomeContentDto>(
      ` *[_type == "home" && language == "${homeLanguage}"] {
...
}[0]`,
    )

    const parsedResult = homeContentDtoSchema.safeParse(result)

    return parsedResult.success ? parsedResult.data : null
  }
}
